import { useAppDispatch, useAppSelector } from '../store'
import { 
    selectContextFilters as selectContextFiltersInState, 
    setContextFilters as setContextFiltersInState
} from 'store/applicationSlice'

export const useContextFilters = () => {
    const dispatch = useAppDispatch()
    const contextFiltersFromState = useAppSelector(selectContextFiltersInState) 
    const selectContextFilters = contextFiltersFromState

    const setContextFilters = (contextFilters: any) => {
        dispatch(setContextFiltersInState(contextFilters))
    }
  
    return {
        selectContextFilters,
        setContextFilters
    }
}